import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "content", "accounts", "list", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--payables--annual--dashboard`
  }

  doPayablesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-12 px-0" data-${this.controllerName}-target="list" data-controller="financials--books--payables--annual--index"></div>
                </div>`
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--books--payables--dashboard--main").contentTarget.innerHTML = html)
    }).then(() => {
      controller.application.annual_payables = []
      controller.getControllerByIdentifier("financials--books--payables--annual--index").doIndexListHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // })

}
